export const useUserInfo = (set, get) => ({
  userInfo: null,
  userById: null,
  setUserInfo: (userInfo) =>
    set((state) => ({
      userInfo: userInfo,
      // userById is a cache for the currently authenticated/impersonated user.
      // Do not retain it when the active identity changes.
      userById:
        state.userById &&
        userInfo &&
        state.userById.id === userInfo.id
          ? state.userById
          : null,
    })),
  setUserById: (userById) => set({ userById: userById }),
  resetUserById: () => set({ userById: null }),
  resetUserInfo: () => set({ userInfo: null }),
});



// WEBPACK FOOTER //
// ./src/store/slices/user/userInfo.js